var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "renew-list-container"
    },
    [
      !_vm.servicesPopulated
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-center py-8"
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "62"
                }
              })
            ],
            1
          )
        : _vm.eligibleServices.length === 0
        ? _c(
            "div",
            {
              staticClass: "text-center py-8"
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    color: "grey",
                    size: "64"
                  }
                },
                [_vm._v("mdi-information-outline")]
              ),
              _c(
                "h4",
                {
                  staticClass: "mt-3 grey--text"
                },
                [_vm._v("No services available for early renewal")]
              ),
              _c(
                "p",
                {
                  staticClass: "grey--text text--darken-1"
                },
                [
                  _vm._v(
                    " You don't have any services eligible for early renewal at this time. "
                  )
                ]
              )
            ],
            1
          )
        : [
            _c(
              "p",
              {
                staticClass: "mb-5 text-center"
              },
              [
                _vm._v(
                  " Select a service below to view renewal options and lock in savings. "
                )
              ]
            ),
            _c(
              "v-row",
              {
                attrs: {
                  justify: "center"
                }
              },
              _vm._l(_vm.eligibleServices, function(service) {
                return _c(
                  "v-col",
                  {
                    key: service.id,
                    staticClass: "d-flex",
                    attrs: {
                      cols: "12",
                      sm: "6",
                      lg: "4"
                    }
                  },
                  [
                    _c("renew-service-tile", {
                      staticClass: "flex-grow-1",
                      attrs: {
                        service: service
                      },
                      on: {
                        click: function click($event) {
                          return _vm.openRenewalModal(service)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              1
            )
          ],
      _vm.selectedServiceId
        ? _c("renew-now-modal", {
            ref: "renewNowModal",
            attrs: {
              "service-id": _vm.selectedServiceId,
              "preferred-term": _vm.preferredTerm
            },
            on: {
              "renewal-complete": _vm.handleRenewalComplete
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }